exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-tabs[data-v-ab99cc06]{margin-top:2em}.tab[data-v-ab99cc06]{border:1px solid #ddd;border-radius:4px}.tab .tab-content[data-v-ab99cc06]{padding:2em 2%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ab99cc06","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/Components/Checkout/PaymentDetails.vue
// module id = osUD
// module chunks = 0